import { render } from "./MainPageLoadingView.vue?vue&type=template&id=e2e01790&scoped=true"
import script from "./MainPageLoadingView.vue?vue&type=script&lang=js"
export * from "./MainPageLoadingView.vue?vue&type=script&lang=js"

import "./MainPageLoadingView.vue?vue&type=style&index=0&id=e2e01790&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e01790"]])

export default __exports__